import React from 'react';
import { Divider, Drawer, Icon, List, ListItemIcon, ListItemText } from '@material-ui/core';
import { BoolControlProps } from '@domain/types/prop.types';
import { MainMenuContainer } from '@components/app.chrome/main.menu.styles';
import { ListLink } from '@components/list.link';
import { useMenuOptions } from '@data/menu.options.data';
import { RawListItem } from '@components/raw.list.item';

const MainMenu = ({ open }: BoolControlProps) => {
  const menuOptions = useMenuOptions();

  return (
    <Drawer id='main-menu' anchor='left' open={open.enabled} onClose={open.disable}>
      <MainMenuContainer role='presentation'>
        <List>
          <RawListItem button>
            <ListLink to='/' onClick={open.disable}>
              <ListItemIcon>
                <Icon>home</Icon>
              </ListItemIcon>
              <ListItemText primary='Home' />
            </ListLink>
          </RawListItem>
          {menuOptions.map((o) => (
            <RawListItem key={o.id} button>
              <ListLink to={o.url} onClick={open.disable}>
                <ListItemIcon>
                  <Icon>{o.icon}</Icon>
                </ListItemIcon>
                <ListItemText primary={o.title} secondary={o.description} />
              </ListLink>
            </RawListItem>
          ))}
        </List>
        <Divider />
      </MainMenuContainer>
    </Drawer>
  );
};

export default MainMenu;
